type ValueType = number | string | boolean | object

export const setLocalStorage = (name: string, value: ValueType) => {
  let valueString: string = JSON.stringify(value)
  localStorage.setItem(name, valueString)
}

export const getLocalStorage = (name: string) => {
  let resultString: string | null = localStorage.getItem(name)
  if (resultString === null) {
    return null
  }

  return JSON.parse(resultString)
}

export const removeLocalStorage = (name: string) => {
  localStorage.removeItem(name)
}

export const clearLocalStorage = () => {
  localStorage.clear()
}